const initialState = {
  stockIns: [],
  loading: false,
  actionLoading: false,
  error: null
};

const StockInReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_STOCKINS_REQUEST':
      return { ...state, loading: true, error: null };

    case 'FETCH_STOCKINS_SUCCESS':
      return { ...state, loading: false, stockIns: action.payload, error: null };

    case 'FETCH_STOCKINS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'ADD_STOCKIN_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'ADD_STOCKIN_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        stockIns: [action.payload, ...state.stockIns],
        error: null
      };

    case 'ADD_STOCKIN_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'UPDATE_STOCKIN_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'UPDATE_STOCKIN_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        stockIns: state.stockIns.map((item) => (item.stockInID === action.payload.stockInID ? { ...item, ...action.payload } : item)),
        error: null
      };

    case 'UPDATE_STOCKIN_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default StockInReducer;
